/*
 * Report 107: the shot tools of the open panel answer to keys as well. Alt+Shift+<letter> by key position (the letter
 * differs per layout), as Alt+Shift+M of the screen mode; a modifier chord, so it works inside the fields too.
 * Quint hotkeys (Кл5–Кл8): one chord per action, by position, silent off the open panel and under another dialog, and the
 * hint of a button is the chord that works (`chordLabel` of the same code).
 */

/** Key positions (`event.code`) of the chords. Both chords of the table are here; `isScreenMaskKey` (screenMask.ts) reads `SCREEN_MASK_CODE` from it. */
export const AREA_CODE = 'KeyS';
export const SCREEN_MASK_CODE = 'KeyM';

/** «Alt+Shift+S» for `KeyS`: the hint is made from the code, not typed beside it. */
export const chordLabel = (code: string): string => `Alt+Shift+${code.replace(/^Key/, '')}`;

export const AREA_HOTKEY = chordLabel(AREA_CODE);

export const isChord = (event: KeyboardEvent, code: string): boolean => event.altKey && event.shiftKey && !event.ctrlKey && !event.metaKey && event.code === code;

/** «Снимок области» — the frame opens. */
export const isAreaShotKey = (event: KeyboardEvent): boolean => isChord(event, AREA_CODE);

/** Another window is open over the panel (the shot viewer, a modal of the host page): the shot keys stay quiet (Кл7). */
export const dialogOver = (): boolean => document.querySelector('[aria-modal="true"], dialog[open]') !== null;
